import { useUserStore } from '@/stores/user'
import { hasAuthToken } from '@/common/plugins/axios'

export const authGuard = async (to: any) => {
  const userStore = useUserStore()


  // Если маршрут требует авторизации
  if (to.meta.requiresAuth) {
    // Если уже аутентифицирован по состоянию - пропускаем
    if (userStore.isAuthenticated) {
      return true
    }
    const wasAuthenticated = userStore.isAuthenticated

    // Проверяем наличие токена (localStorage или cookies) или session cookies
    const hasToken = userStore.token || hasAuthToken()
    const hasSessionCookies = document.cookie.includes('JSESSIONID=') || document.cookie.includes('CSRF-TOKEN=')
    
    if (hasToken || hasSessionCookies) {
      try {
        // Если токен есть только в cookies, или есть токен но нет user, или есть session cookies, попробуем инициализировать
        if ((!userStore.token && hasAuthToken()) || (userStore.token && !userStore.user) || (hasSessionCookies && !userStore.isAuthenticated)) {
          await userStore.initAuth()
        }
        
        if (!userStore.isAuthenticated || !wasAuthenticated) {
          const isAuthenticated = await userStore.checkAuth()
          if (!isAuthenticated) {
            return {
              name: 'signin',
              query: { redirect: to.fullPath }
            }
          }
        }
        
        return true
      } catch (error) {
        console.error('Auth check error:', error)
        return {
          name: 'signin',
          query: { redirect: to.fullPath }
        }
      }
    } else {
      // Нет токена и нет session cookies - на страницу входа
      return {
        name: 'signin',
        query: { redirect: to.fullPath }
      }
    }
  }

  // Если пользователь авторизован и пытается зайти на страницу входа
  if (to.name === 'signin' && userStore.isAuthenticated) {
    console.log('🔄 Authenticated user on signin page, redirecting to home')
    return { name: 'home' }
  }

  return true
}
